import { LoaderFunctionArgs, redirect } from 'react-router-dom'

import { createChargingPointQueryOptions } from '@/api/charging-points/options'

import { queryClient } from '@/config/react-query'

import { HttpError } from '@/api/http'
import { routeParser } from '@/routes/helpers/parser'
import { AppRoutes } from '@/routes/types/routes'
import { Logger } from '@/lib/logger'
import { ChargingPointStatus } from '@/types/ChargingPoint'

const logger = new Logger('ChargingPointLoader')

export default async ({ params }: LoaderFunctionArgs) => {
  logger.info('Carregando ponto de carregamento', params)

  const fallbackRoute = routeParser(AppRoutes.STATION_CHARGERS, { stationId: params.stationId! })

  const redirectWithReason = (reason: string) => redirect(`${fallbackRoute}?error=${encodeURIComponent(reason)}`)

  let chargingPoint
  try {
    chargingPoint = await queryClient.ensureQueryData(
      createChargingPointQueryOptions({
        chargingPointId: Number(params.chargingPointId),
        stationId: Number(params.stationId),
      })
    )
  } catch (error) {
    if (error instanceof HttpError && error.status === 404) {
      logger.error('Ponto de carregamento não encontrado (404)', { error, params })
      throw redirectWithReason('Ponto de carregamento não encontrado.')
    }

    if (error instanceof HttpError && error.status === 403) {
      logger.error('Estação indisponível (403)', { error, params })
      throw redirect(`${AppRoutes.STATIONS}?error=${encodeURIComponent(error.message)}`)
    }

    logger.error('Erro ao carregar ponto de carregamento', { error, params })
    throw error
  }

  if (!chargingPoint) {
    logger.error('Ponto de carregamento não encontrado', { chargingPoint, params })
    throw redirectWithReason('Ponto de carregamento não encontrado.')
  }

  if (chargingPoint.under_maintenance || chargingPoint.status === ChargingPointStatus.MAINTENANCE) {
    logger.error('Ponto de carregamento em manutenção', { chargingPoint, params })
    throw redirectWithReason('Este ponto de carregamento está em manutenção no momento.')
  }

  logger.success('Ponto de carregamento carregado com sucesso', chargingPoint)
  return chargingPoint
}
